import React from 'react'
import { Typography } from 'antd'
import { UpOutlined, DownOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons'
import styles from '../../Style/LayerOverview.module.scss'

interface OffshoreWindFarmProps {
  showMenuOWF: boolean
  setShowMenuOWF: (show: boolean) => void
  showGlobalShapeFile: boolean
  setShowGlobalShapeFile: (show: boolean) => void
  showGlobalTextShapeFile: boolean
  setShowGlobalTextShapeFile: (show: boolean) => void
}

const OffshoreWindFarm: React.FC<OffshoreWindFarmProps> = ({
   showMenuOWF,
   setShowMenuOWF,
   showGlobalShapeFile,
   setShowGlobalShapeFile,
   showGlobalTextShapeFile,
   setShowGlobalTextShapeFile
 }) => {
  return (
    <>
      <div className={`${styles.menuRow}`}>
        <div className={styles.iconLabel}>
          <div className={styles.boxOffshore} />
          <Typography style={{ marginLeft: 5, color: 'black' }}>Offshore Wind Farms</Typography>
        </div>
        <div className={styles.groupItem}>
          <div
            onClick={() => setShowMenuOWF(!showMenuOWF)}
            style={{ cursor: 'pointer', fontSize: '20px' }}
          >
            {showMenuOWF ?
              <UpOutlined style={{fontSize: 15, paddingRight: 1}} /> :
              <DownOutlined style={{fontSize: 15, paddingRight: 1}} />
            }
          </div>
        </div>
      </div>

      {showMenuOWF && (
        <div style={{ paddingTop: 1 }}>
          <div className={`${styles.menuRow}`} style={{paddingTop: 0}}>
            <div className={styles.iconLabel}>
              <Typography style={{ marginLeft: 40, color: 'black' }}>Polygon</Typography>
            </div>
            <div className={styles.groupItem}>
              <div
                onClick={() => setShowGlobalShapeFile(!showGlobalShapeFile)}
                style={{ cursor: 'pointer', fontSize: '20px' }}
              >
                {showGlobalShapeFile ? <EyeOutlined /> : <EyeInvisibleOutlined />}
              </div>
            </div>
          </div>

          <div className={`${styles.menuRow}`} style={{paddingTop: 0}}>
            <div className={styles.iconLabel}>
              <Typography style={{ marginLeft: 40, color: 'black' }}>Name</Typography>
            </div>
            <div className={styles.groupItem}>
              <div
                onClick={() => setShowGlobalTextShapeFile(!showGlobalTextShapeFile)}
                style={{ cursor: 'pointer', fontSize: '20px' }}
              >
                {showGlobalTextShapeFile ? <EyeOutlined /> : <EyeInvisibleOutlined />}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default OffshoreWindFarm
